import React from "react";
import {Navigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {selectCompanyInfo} from "store/companySlice";
import {mainNavigation} from "constants/mainNavigation";

import MainContainer from "layout/atoms/MainContainer";
import Loader from "layout/atoms/Loader";
// import Topbar from "layout/atoms/Topbar";
// import ContentBox from "layout/atoms/ContentBox";
// import Button from "layout/atoms/Button";

const Dashboard = (props) => {
  const { t, i18n } = useTranslation();
  const companyInfo = useSelector(selectCompanyInfo);

  // Wait for company info to load before determining redirect
  if (companyInfo.status === 'loading' || companyInfo.status === 'idle') {
    return (
      <MainContainer alignCenter>
        <Loader />
      </MainContainer>
    );
  }

  // Filter navigation based on company's enabled apps
  const availableNavItems = mainNavigation.filter(
    (item) => item.top && (!item.app || companyInfo.apps?.includes(item.app))
  );

  // Redirect to the first available top-level navigation item
  const defaultPath = availableNavItems.length > 0
    ? availableNavItems[0].to
    : "/admin/settings"; // Fallback to settings if no other items available

  return (
    <Navigate to={defaultPath} />
    // <MainContainer>
    //   <Topbar>
    //     <h2>{t("dashboard.title")}</h2>
    //   </Topbar>
    // <ContentBox> */}
    // <h3>{t("dashboard.header")}</h3> */}
    // <Button
    //     size="lg"
    //     color="primary"
    //     onClick={() => i18n.changeLanguage("en")}
    //   >
    //     English
    //   </Button>
    //   <br />
    //   <br />
    //   <Button
    //     size="lg"
    //     color="light"
    //     onClick={() => i18n.changeLanguage("pl")}
    //   >
    //     Polski
    //   </Button>
    // </ContentBox>
    // </MainContainer>
  );
};

export default Dashboard;
